/*
  FaD v5.60 — sticky mobile Add to Cart
  --------------------------------------------------------------
  Shows a persistent Add to Cart bar on mobile product pages once
  the main #atc-btn has scrolled out of view.

  It does not add a second cart path. The bar's button forwards a
  click to #atc-btn, so theme.js initATC remains the only code that
  talks to /cart/add, and the new product_added_to_cart publisher in
  fad-cart-pixel-fix.js still sees every add.

  It also mirrors the main button's label, price and disabled state,
  so variant switching keeps the bar honest without duplicating any
  of the variant logic.
*/
(function () {
  'use strict';

  function init() {
    var bar = document.getElementById('fad-sticky-atc');
    var barBtn = document.getElementById('fad-sticky-atc-btn');
    var mainBtn = document.getElementById('atc-btn');
    var priceEl = document.getElementById('fad-sticky-price');
    var mainPrice = document.getElementById('prod-price');
    if (!bar || !barBtn || !mainBtn) return;

    /* forward the click, never duplicate the request */
    barBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (barBtn.disabled) return;
      mainBtn.click();
    });

    /* keep label, price and availability in step with the main button */
    function sync() {
      barBtn.disabled = mainBtn.disabled;
      var label = (mainBtn.getAttribute('data-orig-text') || mainBtn.textContent || '').trim();
      if (label && label !== barBtn.textContent.trim()) barBtn.textContent = label;
      if (priceEl && mainPrice) priceEl.innerHTML = mainPrice.innerHTML;
    }

    if (window.MutationObserver) {
      new MutationObserver(sync).observe(mainBtn, {
        attributes: true, childList: true, subtree: true,
        attributeFilter: ['disabled', 'data-variant', 'data-orig-text']
      });
      if (mainPrice) {
        new MutationObserver(sync).observe(mainPrice, { childList: true, subtree: true });
      }
    }
    document.addEventListener('variant:change', sync);
    sync();

    /* reveal once the real button is above the viewport */
    function show(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        show(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(mainBtn);
    } else {
      var onScroll = function () {
        show(mainBtn.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
